import Vue from 'vue'

const app = {
  state: {
    theme: '',
    color: null,
    multiTab: true
  },
  mutations: {
    TOGGLE_THEME: (state, theme) => {
      Vue.ls.set('DEFAULT_THEME', theme)
      state.theme = theme
    },
    TOGGLE_COLOR: (state, color) => {
      Vue.ls.set('DEFAULT_COLOR', color)
      state.color = color
    },
    TOGGLE_MULTI_TAB: (state, bool) => {
      Vue.ls.set('DEFAULT_MULTI_TAB', bool)
      state.multiTab = bool
    }
  },
  actions: {
    ToggleTheme ({ commit }, theme) {
      commit('TOGGLE_THEME', theme)
    },
    ToggleColor ({ commit }, color) {
      commit('TOGGLE_COLOR', color)
    },
    ToggleMultiTab ({ commit }, bool) {
      commit('TOGGLE_MULTI_TAB', bool)
    }
  }
}

export default app